import { functionsLink } from './functions-link';
//  import admin from 'firebase-admin'
//  const FS = admin.firestore();
//  const CUSTOMER_INVITATION_PATH = 'companies/pych/customerInvitations';

export const fetchOrbits = (travelType, callback) => { // Fetch data from db according to the updated parameters
  const data = {data:{type: travelType}}
  return fetch(functionsLink.getOrbits, {
  //   return fetch(functionsLink.getNewYearOrbits, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};
export const fetchDollarValue = (callback) => {
  fetch(functionsLink.getDollarValue, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};

export const fetchTermsValue = (callback) => {
  fetch(functionsLink.getTermsValue, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};

export const fetchTrainsTermsValue = (callback) => {
  fetch(functionsLink.getTrainsTermsValue, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};
export const fetchPriceListValue = (callback) => {
  fetch(functionsLink.getPriceListValue, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};

export const fetchAirportsAndHours = (callback) => {
  fetch(functionsLink.getairportsAndHours, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};


export const fetchRange2025 = (callback) => {
  fetch(functionsLink.get2025RangeAPI, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};

export const fetchCustomerSettings = (callback) => {
  fetch(functionsLink.getCustomerSettingsCorsAPI, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      console.log(error);
    });
};

export const fetchTrainsOrbits = (callback) => { 
  return fetch(functionsLink.getAllTrainsOrbits, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
      });
};








export const fetchAllOrbits = (callback) => { // Fetch data from db according to the updated parameters
  const data1 = {data:{}}
  fetch(functionsLink.getOrbits, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })      
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
}; 


export const fetchAllNewYearOrbits = (travelType, callback) => { // Fetch data from db according to the updated parameters
  const data = {data:{type: travelType}}
   return fetch(functionsLink.getNewYearOrbits, {
  //  return fetch(functionsLink.getOrbits, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchCurrentAgent = ( id ,callback) => {
  const data = {data:{id: id}}
  console.log(JSON.stringify(data))
  fetch(functionsLink.getCurrentAgent, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    
  })
    .then(response => response.json())
    .then(data => {
      callback(data)
    })
    .catch(error => {
      console.log(error);
    });
};

export const fetchPriceData = (travelType, travelId, carId, callback) => { // Fetch data from db according to the updated parameters

  const data = {data:{type: travelType, orbitId: travelId, carType: carId}}
  fetch(functionsLink.getPrice, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchSaveTravel = (data1, callback) => { // Fetch data from db according to the updated parameters
  return fetch(functionsLink.saveTravel, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*"
      },
      body: JSON.stringify(data1),
    })
      .then(response => response.json())
      .then(data =>{callback(data);  return data; })
      .catch(error => {
          // alert(error)
      });
};

export const fetchSaveTravelTemporary = (data1, callback) => { // Fetch data from db according to the updated parameters
  return fetch(functionsLink.saveTravelTemporary, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*"
      },
      body: JSON.stringify(data1),
    })
      .then(response => response.json())
      .then(data =>{callback(data);  return data; })
      .catch(error => {
          // alert(error)
      });
};

export const fetchUpdateTravel = (data, callback) => {
    return fetch(functionsLink.editTravel, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
      // alert(error);
    });
};

export const fetchSadirTravel = (data, callback) => {
  console.log( "111", JSON.stringify(data))
  return fetch(functionsLink.editSadirTravel, {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  body: JSON.stringify(data),
})
  .then(response => response.json())
  .then(data => callback(data))
  .catch(error => {
    // alert(error);
  });
};


export const fetchDeleteTravel = (data, callback) => {
  return fetch(functionsLink.deleteTravel, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  body: JSON.stringify(data),
})
  .then(response => response.json())
  .then(response => response.json())
  .then(data => callback(data))
  .catch(error => {
    // alert(error);
  });
};

export const fetchDeleteCustomerTravel = (id, callback) => {
  const data = {data:{id: id}}
  return fetch(functionsLink.deleteCustomerTravel, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  body: JSON.stringify(data),
})
  .then(response => response.json())
  .then(data => callback(data))
  .catch(error => {
    // alert(error);
  });
};

export const fetchCarData = (id, callback) => { // Fetch data from db according to the updated parameters
  
  const data1 = {data:{id}}
  fetch(functionsLink.getNameCarById, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};
export const fetchTravelData = (id, type, callback) => { // Fetch data from db according to the updated parameters
  
  const data1 = {data:{type, id}}
  fetch(functionsLink.getNameOrbitById, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchMyTravel = (userId, callback) => { // Fetch data from db according to the updated parameters
  const data1 = {data:{userId}}
  return fetch(functionsLink.getMyTravels, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};
export const fetchMyTravelNotConfirmedYet = (userId, callback) => { // Fetch data from db according to the updated parameters
  const data1 = {data:{userId}}
  return fetch(functionsLink.getTravelNotConfirmedYet, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchStopOptionsData = (callback) => { // Fetch data from db according to the updated parameters
  const data1 = {data:{}}
  fetch(functionsLink.getCities, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })     
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchCarsOptionsData = (callback) => { // Fetch data from db according to the updated parameters
  const data1 = {data:{}}
  fetch(functionsLink.getCarTypes, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data1),
    })      
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchStartLocationOptionsData = (callback) => {
  const data = {data:{}}
  fetch(functionsLink.getStartLocation, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })      
      .then(response => response.json())
      .then(data => {
        // console.log('Fetched data:', data); 
        callback(data);
      })      
      .catch(error => {
      });
};

export const fetchStartLocationData = (id, callback) => { // Fetch data from db according to the updated parameters
  
  const data = {data:{id}}
  fetch(functionsLink.getStartLocationById, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

// get details of customer invitation
export const fetchInvitationDetails = (id , type , date , callback) => { 
  console.log(id , type , date )
  fetch(functionsLink.getInvitationDetails, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({data: {id , type , date}}),
    })     
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const getSadirInvitationDetails = (id , type , date , callback) => { 
  console.log(id , type , date )
  fetch(functionsLink.getSadirInvitationDetails, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({data: {id , type , date}}),
    })     
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const editSadirInvitationDetails = (data , callback) => { 
  console.log(data )
  fetch(functionsLink.editSadirInvitationDetails, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({data: {data}}),
    })     
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => {
          // alert(error)
      });
};

export const fetchSendMessage = () => {
  return fetch(functionsLink.fetchSendMessage, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
    }),
  })
    .then(response => response.json())
    .then(data => {
    })
    .catch(error => {
      return null;
    });
};

export const fetchPaymentDetails = (callback , price , userEmail , id  , currency , phone , maxPayments , minPayments, tripType , customerSettings ,travel) => {
  // const totalPrice = price * 100;
  if(currency == 1 ){
    var totalPrice = (price + 1.5 ) * 100 ;
    console.log(totalPrice)
  }else{
    var totalPrice = (price + 0.45 ) *  100 ;
  }
 if (tripType === 'סדירה') {
    var functionsLinkName =
      customerSettings?.sadirTerminal === 'דרך צדיקים טסט'
        ? functionsLink.fetchPaymentDetailsTestEnv
        : functionsLink.fetchPaymentDetails;
  } else if (tripType === 'רכבת') {
    var functionsLinkName =
      customerSettings?.trainTerminal === 'vahavTerminal'
        ? functionsLink.fetchPaymentDetailsVahavAPI
        : functionsLink.fetchPaymentDetailsVahavTestAPI;
  } else {
    // פרטי
    var functionsLinkName =
      customerSettings?.privateTerminal === 'vahavTerminal'
        ? functionsLink.fetchPaymentDetailsVahavAPI
        : functionsLink.fetchPaymentDetailsVahavTestAPI;
  }
  console.log('functionsLinkName', functionsLinkName)
      return fetch(functionsLinkName, {
      
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': 'http://localhost:3000',
    },
    body: JSON.stringify({
      "terminal": "",
      "user": "",
      "password": "",
      "GoodURL": "",
      "ErrorURL": "https://gateway21.pelecard.biz/sandbox/landingpage",
      "ActionType": "J4",
      "Currency" : currency , 
      "Total": totalPrice,
      "CreateToken": "True",
      "Language": "HE",
      "CustomerIdField": "must",
      "Cvv2Field": "must",
      //"MaxPayments": "12",
      //"MinPayments": "1",
      "MinPaymentsForCredit": "7",
      "FirstPayment": "auto",
      "ShopNo": "001",
      "ParamX": "test payment",
      "maxPayments" : maxPayments , 
      "minPayments" : minPayments , 
      "CssURL": "https://gateway21.pelecard.biz/Content/Css/variant-he-1.css",
      "LogoURL": "https://gateway21.pelecard.biz/Content/images/Pelecard.png",
      "EmailField" : userEmail , 
      "Params" : id + ' ' + phone , 
      "travel": travel , 
    }),
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      callback(data); 
    })
    .catch(error => {
      return null;
    });
};

export const fetchPaymentDetailsRefund = (callback , price ) => {
  const totalPrice = price * 100;
  return fetch(functionsLink.fetchPaymentDetailsRefund, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://pych-customers.web.app',
    },
    body: JSON.stringify({
      "terminal": "0882577012",
      "user": "TestYotam",
      "password": "TestYotam1",
      "GoodURL": "pych-customers.web.app",
      "ErrorURL": "https://gateway21.pelecard.biz/sandbox/landingpage",
      "ActionType": "J4",
      "Currency": "1",
      "Total": totalPrice,
      "CreateToken": "True",
      "Language": "HE",
      "CustomerIdField": "must",
      "Cvv2Field": "must",
      "MaxPayments": "12",
      "MinPayments": "1",
      "MinPaymentsForCredit": "7",
      "FirstPayment": "auto",
      "ShopNo": "001",
      "ParamX": "test payment",
      "CssURL": "https://gateway21.pelecard.biz/Content/Css/variant-he-1.css",
      "LogoURL": "https://gateway21.pelecard.biz/Content/images/Pelecard.png",
    }),
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      callback(data); 
    })
    .catch(error => {
      return null;
    });
};


export const fetchIsConfirmedPaymentDetails = (callback , transactionId ) => {
  return fetch(functionsLink.fetchIsConfirmedPaymentDetails, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'https://pych-customers.firebaseapp.com',
    },
    body: JSON.stringify({
      "transactionId": transactionId,
    }),
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      callback(data); 
    })
    .catch(error => {
      return null;
    });
};






